import React from 'react';
import '../App.css';

const JobCard = ({ job, isSelected, onSelect }) => {
  return (
    <div
      className={`job-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(job.job_url)}
    >
      <h3>{job.title}</h3>
      <p>{job.company}</p>
      <p>{job.location}</p>
      {job.connections?.length > 0 && (
        <span className="connections-count">
          {job.connections.length} Connection{job.connections.length > 1 ? 's' : ''}
        </span>
      )}
    </div>
  );
};

export default JobCard; 